import "./FinalScore.css";

const FinalScore = ({score}) => {
  return (
      <div className="final-score">Final score: {score}</div>
  );
}

export default FinalScore;
